<div [formGroup]="formGroup" *ngIf="formGroup" class="w-full py-1 px-2">
  <div
    class="gap-1 items-start rounded-lg"
    [ngClass]="[
      labelAbove ? 'flex flex-col' : 'grid grid-cols-12 gap-3 items-center',
      twoGridColumn ? 'mb-1' : 'mb-1',
    ]"
  >
    <!-- Label -->
    <label
      for="dropdown"
      [ngClass]="[
        labelAbove
          ? 'text-2sm font-semibold text-gray-700 dark:text-gray-300 mb-1'
          : 'col-span-4 text-2sm font-semibold text-gray-700 dark:text-gray-300 leading-tight',
        fields.isRequired ? 'required' : '',
      ]"
    >
      {{ formatDisplayName(fields.displayName) }}
    </label>

    <!-- ✅ FIXED GRID COLUMN -->
    <div *ngIf="!labelAbove" class="col-span-8">
      <div class="custom-dropdown w-full">
        <div
          #focusInput
          tabindex="0"
          class="dropdown-selected text-2sm text-gray-500 input cursor-pointer border border-gray-300 dark:border-gray-600 rounded-md transition-all duration-150"
          [class.placeholder]="!hasSelection()"
          [class.disabled]="
            disableFields || getControl()?.disabled
          "
          [ngStyle]="{
            color: hasSelection()
              ? getSelectedOptionColor(getControl()?.value)
              : '#808290',
          }"
          (click)="toggleDropdown($event)"
        >
          <span class="ellipsis-text">
            {{ getSelectedDisplay() }}
          </span>
          <span class="arrow" [class.open]="isOpen"></span>
        </div>

        <div
          #dropdownPanel
          class="dropdown-panel bg-white dark:bg-coal-500 border border-gray-200 dark:border-gray-600 rounded-md"
          (click)="$event.stopPropagation()"
          (scroll)="onScroll($event)"
        >
          <div
            class="search-wrapper bg-white dark:bg-coal-500 border-b border-gray-200 dark:border-gray-600"
          >
            <div class="search-input-container">
              <span class="search-icon"></span>
              <input
                #searchInput
                type="text"
                class="search-input bg-white dark:bg-coal-500 text-gray-600 dark:text-gray-300 search-field"
                placeholder="Search..."
                (input)="onKeyUpSearch(searchInput.value)"
                (keydown.escape)="closeDropdown()"
                (keydown.enter)="
                  $event.preventDefault(); $event.stopPropagation()
                "
              />

              <button
                *ngIf="searchInput.value"
                type="button"
                class="clear-btn text-xl"
                (click)="clearSearch(searchInput)"
              >
                ×
              </button>
            </div>
          </div>

          <div
            class="dropdown-option flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors duration-100"
            [class.bg-blue-50]="!fields?.multiselect && isSelected(option)"
            [class.dark:bg-blue-900/20]="!fields?.multiselect && isSelected(option)"
            [class.text-blue-600]="!fields?.multiselect && isSelected(option)"
            [class.dark:text-blue-400]="!fields?.multiselect && isSelected(option)"
            [class.font-medium]="!fields?.multiselect && isSelected(option)"
            *ngFor="let option of fieldsData"
            (click)="selectOption(option)"
          >
            <!-- ✅ Checkbox only for multiselect -->
            <input
              *ngIf="fields?.multiselect && fields?.fieldName !== 'config.region'"
              type="checkbox"
              [checked]="isSelected(option)"
              (click)="selectOption(option); $event.stopPropagation()"
              class="cursor-pointer checkbox checkbox-2sm"
            />
            <ng-container
              *ngIf="
                fields?.fieldName === 'owners' ||
                  fields?.fieldName === 'assignee' ||
                  fields?.fieldName === 'assigned' ||
                  formId === '6878d3800453556c08933e90' ||
                  formId === FORM_ID.USERS;
                else defaultOption
              "
            >
              <div class="flex items-center gap-2 py-0.5">
                <img
                  *ngIf="hasValidPhoto(option.profilePhoto)"
                  [src]="option.profilePhoto"
                  (error)="handleImageError($event)"
                  alt="Profile"
                  class="w-7 h-7 rounded-full object-cover flex-shrink-0"
                />
                <div
                  *ngIf="!hasValidPhoto(option.profilePhoto)"
                  class="avatar-circle flex items-center justify-center text-white text-2xs font-semibold rounded-full w-7 h-7 flex-shrink-0"
                  [style.background-color]="
                    getAvatarColor(getOptionLabel(option))
                  "
                >
                  {{ getInitials(getOptionLabel(option)) }}
                </div>
                <div class="flex flex-col min-w-0">
                  <span
                    class="text-2sm font-medium leading-tight text-gray-700 dark:text-gray-300 truncate"
                    >{{ option.name || option.fullName || option.text || option.label || option.email }}</span
                  >
                  <span
                    class="text-xs text-gray-500 leading-tight truncate"
                    *ngIf="option.email && (option.name || option.fullName || option.text || option.label)"
                    >{{ option.email }}</span
                  >
                </div>
              </div>
            </ng-container>
            <ng-template #defaultOption>
              {{ getOptionLabel(option) }}
            </ng-template>
          </div>

          <div *ngIf="fieldsData.length === 0" class="no-data">
            No results found
          </div>
        </div>
      </div>
    </div>

    <!-- For labelAbove layout -->
    <div *ngIf="labelAbove" class="w-full">
      <div class="custom-dropdown w-full">
        <div
          #focusInput
          tabindex="0"
          class="dropdown-selected text-2sm text-gray-500 input cursor-pointer border border-gray-300 dark:border-gray-600 rounded-md transition-all duration-150"
          [class.placeholder]="!hasSelection()"
          [class.disabled]="
            disableFields || getControl()?.disabled
          "
          [ngStyle]="{
            color: hasSelection()
              ? getSelectedOptionColor(getControl()?.value)
              : '#808290',
          }"
          (click)="toggleDropdown($event)"
        >
          <span class="ellipsis-text">
            {{ getSelectedDisplay() }}
          </span>
          <span class="arrow" [class.open]="isOpen"></span>
        </div>

        <div
          #dropdownPanel
          class="dropdown-panel bg-white dark:bg-coal-500 border border-gray-200 dark:border-gray-600 rounded-md"
          (click)="$event.stopPropagation()"
          (scroll)="onScroll($event)"
        >
          <div
            class="search-wrapper bg-white dark:bg-coal-500 border-b border-gray-200 dark:border-gray-600"
          >
            <div class="search-input-container">
              <span class="search-icon"></span>
              <input
                #searchInput
                type="text"
                class="search-input bg-white dark:bg-coal-500 text-gray-600 dark:text-gray-300 search-field"
                placeholder="Search..."
                (input)="onKeyUpSearch(searchInput.value)"
                (keydown.escape)="closeDropdown()"
                (keydown.enter)="
                  $event.preventDefault(); $event.stopPropagation()
                "
              />
              <button
                *ngIf="searchInput.value"
                type="button"
                class="clear-btn text-xl text-gray-600 dark:text-gray-300"
                (click)="clearSearch(searchInput)"
              >
                ×
              </button>
            </div>
          </div>

          <div
            class="dropdown-option flex items-center gap-2 text-gray-600 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors duration-100"
            [class.bg-blue-50]="!fields?.multiselect && isSelected(option)"
            [class.dark:bg-blue-900/20]="!fields?.multiselect && isSelected(option)"
            [class.text-blue-600]="!fields?.multiselect && isSelected(option)"
            [class.dark:text-blue-400]="!fields?.multiselect && isSelected(option)"
            [class.font-medium]="!fields?.multiselect && isSelected(option)"
            *ngFor="let option of fieldsData"
            (click)="selectOption(option)"
          >
            <!-- ✅ Checkbox only for multiselect -->
            <input
              *ngIf="fields?.multiselect && fields?.fieldName !== 'config.region'"
              type="checkbox"
              [checked]="isSelected(option)"
              (click)="selectOption(option); $event.stopPropagation()"
              class="cursor-pointer checkbox checkbox-2sm"
            />
            <ng-container
              *ngIf="
                fields?.fieldName === 'owners' ||
                  fields?.fieldName === 'assignee' ||
                  fields?.fieldName === 'assigned' ||
                  formId === '6878d3800453556c08933e90' ||
                  formId === FORM_ID.USERS;
                else defaultOption
              "
            >
              <div class="flex items-center gap-2 py-0.5">
                <img
                  *ngIf="hasValidPhoto(option.profilePhoto)"
                  [src]="option.profilePhoto"
                  (error)="handleImageError($event)"
                  alt="Profile"
                  class="w-7 h-7 rounded-full object-cover flex-shrink-0"
                />
                <div
                  *ngIf="!hasValidPhoto(option.profilePhoto)"
                  class="avatar-circle flex items-center justify-center text-white text-2xs font-semibold rounded-full w-7 h-7 flex-shrink-0"
                  [style.background-color]="
                    getAvatarColor(getOptionLabel(option))
                  "
                >
                  {{ getInitials(getOptionLabel(option)) }}
                </div>
                <div class="flex flex-col min-w-0">
                  <span
                    class="text-2sm font-medium leading-tight text-gray-700 dark:text-gray-300 truncate"
                    >{{ option.name || option.fullName || option.text || option.label || option.email }}</span
                  >
                  <span
                    class="text-xs text-gray-500 leading-tight truncate"
                    *ngIf="option.email && (option.name || option.fullName || option.text || option.label)"
                    >{{ option.email }}</span
                  >
                </div>
              </div>
            </ng-container>
            <ng-template #defaultOption>
              {{ getOptionLabel(option) }}
            </ng-template>
          </div>

          <div *ngIf="fieldsData.length === 0" class="no-data">
            No results found
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
